import { render, staticRenderFns } from "./ChoicesModal.vue?vue&type=template&id=acfd61c4&scoped=true&"
import script from "./ChoicesModal.vue?vue&type=script&lang=js&"
export * from "./ChoicesModal.vue?vue&type=script&lang=js&"
import style0 from "./ChoicesModal.vue?vue&type=style&index=0&id=acfd61c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfd61c4",
  null
  
)

export default component.exports